import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Privilege, UserRole } from 'types/users';

interface UserPrivilegesProps {
    selectedRole: UserRole | null
}

const UserPrivileges: React.FC<UserPrivilegesProps> = ({ selectedRole }) => {

    const roles = useSelector((state: RootState) => state.roles.items);

    const [privileges, setPrivileges] = useState<Privilege[]>([]);

    useEffect(() => {
        if (selectedRole) {
            const role = roles.find((role) => selectedRole.slug === role.slug);
            if (role && Array.isArray(role.privileges)) {
                setPrivileges(role.privileges);
            }
        }
    }, [roles, selectedRole])

    const [objects, setObjects] = useState<Record<string, string[]>>({});

    useEffect(() => {
        setObjects(() => {
            const objMap: Record<string, string[]> = {};
            privileges.forEach(({ object, type }) => {
                if (!objMap[object.name]) {
                    objMap[object.name] = [];
                }
                if (!objMap[object.name].includes(type.name)) {
                    objMap[object.name].push(type.name);
                }
            });
            return objMap;
        });
    }, [privileges]);



    return (
        <ul className="list-group list-group-flush privileges-list">
            {Object.entries(objects).map(([object, types]) => (
                <li key={object} className="px-3 privileges-list-item list-group-item px-0 d-flex justify-content-between">
                    <div className="left privilege-type">{object}</div>
                    <div className="d-flex justify-content-end align-items-center">
                        {types.map((v, i) => (
                            <div key={i} className="badge bg-secondary ms-2 p-2">
                                {v}
                            </div>
                        ))}
                    </div>
                </li>
            ))}
        </ul>
    )
}

export default UserPrivileges